<template>
	<div class="wrap-layer">
		<light-header :back="'/user-space/contracts?status=all'"></light-header>
		<div class="steps">
			<div class="step">
				<span class="circle">
					<i class="el-icon-check" style="color: #3699FF;font-weight: bold"></i>
				</span>
				选择套餐
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step active">
				<span class="circle">2</span>
				在线支付
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step">
				<span class="circle">3</span>
				完成
			</div>
		</div>
		<div class="cart-body auto">
			<div class="head">
				订单信息
			</div>
			<div class="info">
				<div class="cell">
					<div class="label">订单编号</div>
					<div class="value">{{ orderInfo.orderId }}</div>
				</div>
				<div class="cell">
					<div class="label">订单内容</div>
					<div class="value">{{ orderInfo.packageName }}</div>
				</div>
				<div class="cell">
					<div class="label">套餐合同份数</div>
					<div class="value">{{ orderInfo.count }} 份</div>
				</div>
				<div class="cell">
					<div class="label">应付金额</div>
					<div class="value big">￥{{ orderInfo.money }}</div>
				</div>
			</div>
		</div>
		<div class="cart-body auto">
			<div class="head">
				选择支付方式
			</div>
			<div class="pay-way">
				<el-row type="flex">
					<div class="aliPay grid-content">
						<el-row class="aliPay-row" type="flex" justify="space-between">
							<el-col :span="24">
								<el-radio v-model="payWay" label="aliPay" border class="aliPay-radio"></el-radio>
							</el-col>
						</el-row>
					</div>
					<!-- <div class="weChat grid-content">
						<el-row class="weChat-row" type="flex" justify="space-between">
							<el-col :span="24">
								<el-radio v-model="payWay" label="weChat" disabled border class="weChat-radio"></el-radio>
							</el-col>
						</el-row>
					</div> -->
					<!-- <div class="unionPay grid-content">
						<el-row class="unionPay-row" type="flex" justify="space-between">
							<el-col :span="24">
								<el-radio v-model="payWay" label="unionPay" border class="unionPay-radio"></el-radio>
							</el-col>
						</el-row>
					</div> -->
					<div class="grid-content">
						<el-row class="hzd-row" type="flex" justify="space-between">
							<el-col :span="24">
								<el-radio v-model="payWay" label="hzd" border class="hzd-radio">
									<el-icon class="el-icon-s-promotion" style="font-size: 20px; margin-right: 4px">
									</el-icon>电汇
								</el-radio>
							</el-col>
						</el-row>
					</div>
				</el-row>
			</div>
			<div class="pay-label" v-if="payWay == 'hzd'">
				<div>
					<div class="label">打款账户名：</div>
					<div class="val">北京正元安服科技有限公司</div>
				</div>
				<div>
					<div class="label">银行名称：</div>
					<div class="val">交通银行股份有限公司北京中关村园区支行</div>
				</div>
				<div>
					<div class="label">银行卡号：</div>
					<div class="val">110061241018800072330</div>
				</div>
				<div>回执单示例：</div>
				<div>
					<el-image :src="require('@/assets/images/cart/hzd.png')"
						:preview-src-list="[require('@/assets/images/cart/hzd.png')]"></el-image>
				</div>
			</div>
			<div class="pay-btn-wrap">
				<el-button type="primary" size="medium" @click="toPay" :loading="payLoading" :disabled="!payWay"
					v-if="payWay != 'hzd'">立即支付
				</el-button>
				<el-upload :disabled="uploading || !payWay" ref="upload" style="width: 400px;" class="upload-btn"
					:action="uploadUrl" :limit="1" :on-remove="handleRemove" :on-success="uploadSuccess"
					:show-file-list="true" :on-progress="uploadProgressing" :before-upload="beforeUpload"
					:headers="headers" :on-change="handleUploaded" :file-list="fileList" list-type="picture" v-else>
					<el-button type="primary" size="medium" :disabled="uploading || !payWay || fileList.length > 0">
						上传回执单</el-button>
				</el-upload>
				<div class="upload-confirm-btns" v-if="payWay == 'hzd' && fileList.length > 0">
					<el-button size="medium" @click="cancelHzdConfirm">取消
					</el-button>
					<el-button type="primary" size="medium" @click="hzdConfirm" :loading="payLoading">确认
					</el-button>
				</div>

			</div>
		</div>
		<el-dialog title="确认支付结果" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
			append-to-body>
			<span style="font-size: x-large;">请确认支付是否已完成?</span>
			<span slot="footer" class="dialog-footer">
				<el-button id="order_pay_tenant_button_cancel" :disabled="checking" @click="checkPayResult(1)">取消支付
				</el-button>
				<el-button id="order_pay_tenant_button_payed" type="primary" :disabled="checking"
					@click="checkPayResult(2)">支付完成</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import lightHeader from "../../components/lightHeader";
import { mapState } from "vuex";
import { getSalesPackage, payForOrder } from "@/api/cart/cart";
import { getToken } from '@/utils/auth'
export default {
	components: {
		lightHeader
	},
	data() {
		return {
			payUrl: "",
			// 新窗口的引用
			newWin: null,
			cartCount: 0,
			payWay: "",
			dialogVisible: false,
			payLoading: false,
			checking: false,
			uploadUrl: ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/order/uploadFile",
			paymentReceiptAddress: "",
			headers: {
				Authorization: 'Bearer ' + getToken()
			},
			fileList: [],
			uploading: false,
		};
	},
	watch: {
		payUrl(newVal, oldVal) {
			if (newVal && this.newWin) {
				this.newWin.sessionStorage.clear();
				this.newWin.location.href = newVal;
				// 重定向后把url和newWin重置
				this.payUrl = "";
				this.newWin = null;
			}
		}
	},
	computed: {
		...mapState(["orderInfo"])
	},
	created() {
		getSalesPackage().then(res => {
			res.data.packageArray.map(item => {
				item.check = false;
			});
			this.cartList = res.data.packageArray;
		});
	},
	mounted() { },
	methods: {
		toPay() {
			this.payLoading = true;
			const confirmData = {
				orderId: this.orderInfo.orderId,
				payWay:
					this.payWay === "aliPay"
						? "zfb"
						: this.payWay === "weChat"
							? "wx"
							: "yl"
			};
			// 先打开一个空的新窗口，再请求
			if (this.payWay == "aliPay") {
				this.newWin = window.open();
				payForOrder(confirmData)
					.then(res => {
						if (res.code === 200) {
							this.payLoading = false;
							this.payUrl = res.data.payPage;
							this.dialogVisible = true;
						} else {
							this.$notify({
								title: res.message,
								type: "warning",
								duration: 2500
							});
						}
					})
					.catch(err => {
						this.payLoading = false;
						this.$notify({
							title: "暂不支持该付款方式",
							type: "error",
							duration: 2500
						});
					});
			} else if (this.payWay == "weChat") {
			} else {
				payForOrder(confirmData)
					.then(res => {
						if (res.code === 200) {
							this.newWin = window.open();
							this.newWin.sessionStorage.clear();
							this.newWin.location.href = res.message;
							this.newWin.document.write(res.data);
							// 重定向后把url和newWin重置
							this.payUrl = "";
							this.newWin = null;
							this.payLoading = false;
							this.dialogVisible = false;
						} else {
							this.$notify({
								title: "暂不支持该付款方式",
								type: "error",
								duration: 2500
							});
							// 重定向后把url和newWin重置
							this.payUrl = "";
							this.newWin = null;
							this.payLoading = false;
							this.dialogVisible = false;
						}
					})
					.catch(err => {
						this.payLoading = false;
						this.$notify({
							title: "暂不支持该付款方式",
							type: "error",
							duration: 2500
						});
					});
			}
		},
		checkPayResult(result) {
			this.checking = true;
			if (result === 1) {
				setTimeout(() => {
					this.dialogVisible = false;
					this.$router.replace({
						path: "/user-space/contracts?status=all"
					});
				}, 1100);
			} else {
				setTimeout(() => {
					this.dialogVisible = false;
					if (result === 3) {
						this.$router.replace({
							path: "/cart/success?audit=yes"
						});
					} else {
						this.$router.replace({
							path: "/cart/success"
						});

					}

				}, 1100);
			}
		},
		beforeUpload() { },
		handleRemove() {
			this.paymentReceiptAddress = "";
			this.fileList = [];
		},
		uploadSuccess(res, file, fileList) {
			this.paymentReceiptAddress = res.paymentReceiptAddress;
			this.fileList = fileList
		},
		handleUploaded() {
			this.uploading = false;
		},
		uploadProgressing() {
			this.uploading = true;
		},
		cancelHzdConfirm() {
			this.$refs.upload.clearFiles();
			this.paymentReceiptAddress = "";
			this.fileList = [];
		},
		hzdConfirm() {
			if (this.paymentReceiptAddress) {
				this.payLoading = true;
				const confirmData = {
					orderId: this.orderInfo.orderId,
					payWay: this.payWay,
					paymentReceiptAddress: this.paymentReceiptAddress
				};
				payForOrder(confirmData)
					.then(res => {
						if (res.code === 200) {
							this.payLoading = false;
							this.checkPayResult(3);
						} else {
							this.$notify({
								title: res.message,
								type: "warning",
								duration: 2500
							});
						}
					})
					.catch(err => {
						this.payLoading = false;
						this.$notify({
							title: "暂不支持该付款方式",
							type: "error",
							duration: 2500
						});
					});
			}
		}
	}
};
</script>
<style lang="scss">
.steps {
	width: 441px;
	margin: 20px auto;
	display: flex;
	justify-content: space-around;
	align-items: center;

	.step {
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.circle {
			display: block;
			width: 34px;
			height: 34px;
			border: 1px solid #dedcdb;
			border-radius: 50%;
			text-align: center;
			line-height: 34px;
			font-weight: 400;
			color: #c3c3c3;
			font-size: 16px;
			margin-right: 12px;
		}

		&.active {
			.circle {
				background: #3296fa;
				color: #fff;
			}

			color: #3699ff;
			border: none;
		}
	}
}
</style>
<style lang="scss" scoped>
.wrap-layer {
	background: #f0f0f5;
	min-height: 100vh;

	.cart-body {
		background: #fff;
		padding: 27px 30px;
		position: relative;

		.head {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
			border-left: 3px solid #3296fa;
			height: 20px;
			line-height: 20px;
			padding-left: 14px;
		}

		.info {
			padding-left: 25px;
			padding-top: 15px;

			.cell {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				font-size: 14px;
				color: #333;
				line-height: 35px;

				.label {
					width: 150px;
				}

				.big {
					color: #3296fa;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}
	}

	.cart-body+.cart-body {
		margin-top: 20px;
	}

	.pay-way {
		padding: 30px 20px;

		.grid-content {
			display: flex;
			// align-items: center;
			// height: 40px;

			>div {
				margin-right: 18px;
			}

			.aliPay-row img {
				width: 90px;
				height: auto;
			}

			.weChat-row img {
				width: 110px;
				height: auto;
			}

			.el-radio {
				width: 120px;
				height: 50px;

				/deep/ .el-radio__input,
				/deep/ .el-radio__label {
					display: none;
				}

				&.is-disabled {
					opacity: 0.5;
					border-color: #dcdfe6;

					/deep/ .el-radio__label {
						color: #606266;
					}
				}
			}

			.hzd-row {
				/deep/ .el-radio__label {
					// display: block;
					font-size: 16px;
					text-align: center;
					line-height: 24px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}

			.aliPay-radio {
				background: url(../../assets/images/cart/alipay.png) no-repeat;
				background-size: 80%;
				background-position: 50%;
			}

			.weChat-radio {
				background: url(../../assets/images/cart/wechat_pay.png) no-repeat;
				background-size: 90%;
				background-position: 50%;
			}

			.unionPay-radio {
				background: url(../../assets/images/cart/unionpay.png) no-repeat;
				background-size: 70%;
				background-position: 50%;
			}

			.public-radio {
				/deep/ .el-radio__label {
					display: block;
					font-size: 18px;
					font-weight: 400;
					text-align: center;
					margin-top: 2px;
				}
			}
		}
	}

	.pay-btn-wrap {
		margin-top: 30px;
		padding-left: 20px;


	}

	.pay-label {
		padding-left: 20px;
		font-size: 14px;
		color: #333;
		line-height: 31px;

		>div {
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.label {
				width: 100px
			}
		}

		.el-image {
			width: 400px;
		}
	}

	.upload-confirm-btns {
		margin-top: 30px;

		.el-button {
			margin-right: 25px;
		}
	}
}
</style>
